import request from '@/utils/request'
const uc = window.context.uc

// 用户选择器 获取用户列表
export function getUserSelectorList(data) {
  return request({
    url: `${context.uc}/api/user/v1/users/queryByType`,
    method: 'post',
    data,
  })
}
// 用户选择器
export function getByParentAndDem(data) {
  return request({
    url: `${context.uc}/api/org/v1/orgs/getByParentAndDem`,
    method: 'post',
    data,
  })
}
// 用户选择器 获取权限
export function getUserSelectorDem() {
  return request({
    url: `${context.uc}/api/demension/v1/dems/getAll`,
    method: 'get',
  })
}
// 组织选择器 获取列表
export function getOrgSelectorList(data) {
  return request({
    url: `${context.uc}/api/org/v1/orgs/getOrgPage`,
    method: 'post',
    data,
  })
}

// 角色选择器 获取列表
export function getRoleSelectorList(data) {
  return request({
    url: `${context.uc}/api/role/v1/roles/getRolePage`,
    method: 'post',
    data,
  })
}
// 职务选择器 获取列表
export function getJobSelectorList(data) {
  return request({
    url: `${context.uc}/api/job/v1/jobs/getJobPage`,
    method: 'post',
    data,
  })
}
// 岗位选择器 获取列表
export function getOrgPostSelectorList(data) {
  return request({
    url: `${context.uc}/api/org/v1/orgPosts/getOrgPostPage`,
    method: 'post',
    data,
  })
}
// 维度选择器 获取列表
export function getDemSelectorList(data) {
  return request({
    url: `${context.uc}/api/demension/v1/dems/getDemListAll`,
    method: 'post',
    data,
  })
}

//获取租户信息
export function getTenantInfo(tenant, cb) {
  return request({
    url: `${uc}/uc/tenantManage/v1/getTenantByCode?code=${tenant}`,
    method: 'get',
  })
}

// 校验当前登录用户的电子签章密码
export function getCurrentSeal(password, secretFree) {
  return request({
    url: `${uc}/uc/electronicSeal/v1/getElectronicSeal?password=${password}&secretFree=${secretFree}`,
    method: 'get',
  })
}

// 获取签章信息
export function getSealByCurrentUserId() {
  return request({
    url: `${uc}/uc/electronicSeal/v1/getSealByCurrentUserId`,
    method: 'get',
  })
}
export function getDefaultPwdStrategy() {
  return request.get(`${uc}/api/pwdStrategy/v1/getDefault`)
}
export function resetPassword(params) {
  return request({
    url: `${uc}/api/user/v1/user/modifiUserPsd`,
    method: 'post',
    data: params,
  })
}
